/*
 *
 * Flow constants
 *
 */

// Saga
export const LOAD_FLOW = 'app/Flow/LOAD_FLOW';
export const LOAD_FLOW_SUCCESS = 'app/Flow/LOAD_FLOW_SUCCESS';
export const LOAD_FLOW_ERROR = 'app/Flow/LOAD_FLOW_ERROR';
export const INITIALIZE_LAUNCH_CONTEXT = 'app/Flow/INITIALIZE_LAUNCH_CONTEXT';
export const SET_LAUNCH_CONTEXT = 'app/Flow/SET_LAUNCH_CONTEXT';
export const LOAD_NODE = 'app/Flow/LOAD_NODE';
export const LOAD_NODE_SUCCESS = 'app/Flow/LOAD_NODE_SUCCESS';
export const LOAD_NODE_ERROR = 'app/Flow/LOAD_NODE_ERROR';
export const LOAD_CUSTOMER_SUCCESS = 'app/Flow/LOAD_CUSTOMER_SUCCESS';
export const LOAD_CUSTOMER_ERROR = 'app/Flow/LOAD_CUSTOMER_ERROR';
export const RESET_FLOW = 'app/Flow/RESET_FLOW';
export const SETUP_CURRENT_STATE = 'app/Flow/SETUP_CURRENT_STATE';
export const CHANGE_RESPONSE = 'app/Flow/CHANGE_RESPONSE';
export const SAVE_INCOMPLETE_SURVEY = 'app/Flow/SAVE_INCOMPLETE_SURVEY';
export const SET_QUESTION = 'app/Flow/SET_QUESTION';
export const UPDATE_ELEMENT = 'app/Flow/UPDATE_ELEMENT';
export const NEXT_STATE = 'app/Flow/NEXT_STATE';
export const PREVIOUS_STATE = 'app/Flow/PREVIOUS_STATE';
export const TOGGLE_AGREEMENT_MODAL = 'app/Flow/TOGGLE_AGREEMENT_MODAL';
export const UPLOAD_FILE = 'app/Flow/UPLOAD_FILE';
export const REMOVE_FILE = 'app/Flow/REMOVE_FILE';
export const SET_PHONE_VERIFICATION_DATA = 'app/Flow/SET_PHONE_VERIFICATION_DATA';
export const SEND_VERIFICATION_TOKEN = 'app/Flow/SEND_VERIFICATION_TOKEN';
export const VERIFY_PHONE_NUMBER = 'app/Flow/VERIFY_PHONE_NUMBER';
export const DO_DYNAMIC_REQUEST = 'app/Flow/DO_DYNAMIC_REQUEST';
export const TOGGLE_DROPDOWN = 'app/Flow/TOGGLE_DROPDOWN';
export const CLEAR_RESPONSES_ON_STATE = 'app/Flow/CLEAR_RESPONSES_ON_STATE';
export const RESET_IDLE_TIMEOUT = 'app/Flow/RESET_IDLE_TIMEOUT';
export const SET_ANIMATIONS_ENABLED = 'app/Flow/SET_ANIMATIONS_ENABLED';
export const SET_DEFAULT_PLACEHOLDER = 'app/Flow/SET_DEFAULT_PLACEHOLDER';
export const SET_FIRST_RESPONSE_TIME = 'app/Flow/SET_FIRST_RESPONSE_TIME';
export const SMS_UNSUBSCRIBE = 'app/Flow/SMS_UNSUBSCRIBE';
export const WHATSAPP_UNSUBSCRIBE = 'app/Flow/WHATSAPP_UNSUBSCRIBE';
export const PUSH_NOTIFICATION_UNSUBSCRIBE = 'app/Flow/PUSH_NOTIFICATION_UNSUBSCRIBE';
export const CUSTOMER_UNSUBSCRIBED = 'app/Flow/CUSTOMER_UNSUBSCRIBED';
export const WHATSAPP_CUSTOMER_UNSUBSCRIBED = 'app/Flow/WHATSAPP_CUSTOMER_UNSUBSCRIBED';
export const PUSH_NOTIFICATION_CUSTOMER_UNSUBSCRIBED = 'app/Flow/PUSH_NOTIFICATION_CUSTOMER_UNSUBSCRIBED';
export const UNSUBSCRIPTION_REQUESTED = 'app/Flow/UNSUBSCRIPTION_REQUESTED';
export const WHATSAPP_UNSUBSCRIPTION_REQUESTED = 'app/Flow/WHATSAPP_UNSUBSCRIPTION_REQUESTED';
export const PUSH_NOTIFICATION_UNSUBSCRIPTION_REQUESTED = 'app/Flow/PUSH_NOTIFICATION_UNSUBSCRIPTION_REQUESTED';
export const SEND_POST_MESSAGE = 'app/Flow/SEND_POST_MESSAGE';
export const SET_FEEDBACK_RESPONSE = 'app/Flow/SET_FEEDBACK_RESPONSE';
export const SET_SUBMISSION_STATUS = 'app/Flow/SET_SUBMISSION_STATUS';
export const SET_IS_CHANGING_STATE = 'app/Flow/SET_IS_CHANGING_STATE';
export const SET_IS_SUBMIT_ERROR = 'app/Flow/SET_IS_SUBMIT_ERROR';
export const SEND_CHANNEL_QUOTA_LOG = 'app/Flow/SEND_CHANNEL_QUOTA_LOG';
export const SET_PREVENT_MULTIPLE_FEEDBACK = 'app/Flow/SET_PREVENT_MULTIPLE_FEEDBACK';
export const SET_PRELOADED_RESPONSES = 'app/Flow/SET_PRELOADED_RESPONSES';
export const SET_RESPONSES_LOADED = 'app/Flow/SET_RESPONSES_LOADED';
export const SET_INCOMPLETE_HYDRATION_STATUS = 'app/Flow/SET_INCOMPLETE_HYDRATION_STATUS';
export const SET_CAPTCHA_CONFIGURATION = 'app/Flow/SET_CAPTCHA_CONFIGURATION';
export const RESET_CAPTCHA_CONFIGURATION = 'app/Flow/RESET_CAPTCHA_CONFIGURATION';
export const SET_SECURITY_CONTEXT_STATUS = 'app/Flow/SET_SECURITY_CONTEXT_STATUS';
export const REQUEST_ALTCHA_VERIFICATION = 'app/Flow/REQUEST_ALTCHA_VERIFICATION';
export const SET_ALTCHA_STATUS = 'app/Flow/SET_ALTCHA_STATUS';
export const SET_ALTCHA_TOKEN = 'app/Flow/SET_ALTCHA_TOKEN';
export const SET_AWAITING_ALTCHA_VERIFICATION = 'app/Flow/SET_AWAITING_ALTCHA_VERIFICATION';
export const SET_PENDING_ALTCHA_STATE_CHANGE_PARAMS = 'app/Flow/SET_PENDING_ALTCHA_STATE_CHANGE_PARAMS';
export const RESET_ALTCHA_STATE = 'app/Flow/RESET_ALTCHA_STATE';

// Others
// Client-side submit error; server errors keep their numeric API codes.
export const OFFLINE_SAVE_FAILED = 'offline_save_failed';
export const SUBMISSION_STATUS = { IDLE: 'idle', PENDING: 'pending', COMPLETED: 'completed', QUEUED: 'queued' };
// Retired localStorage queue; its entries are discarded without migration.
export const LEGACY_FEEDBACK_QUEUE = 'FEEDBACK_QUEUE';
export const EMAIL_REGEX =
  /^$|^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,8})[\W]*$/; // Null or Valid Email
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const DEFAULT_COUNTRY_CODE = 'tr';
export const FLOW_ANSWERS = 'FLOW/';
export const DEVICE_ID = 'DEVICE_ID';
export const INCOMPLETE_SURVEYS = 'INCOMPLETE_SURVEYS';
export const PISANO_SESSION = 'PISANO_SESSION';

// Launch Context Status
export const LAUNCH_CONTEXT_STATUS_IDLE = 'idle';
export const LAUNCH_CONTEXT_STATUS_LOADING = 'loading';
export const LAUNCH_CONTEXT_STATUS_READY = 'ready';
export const LAUNCH_CONTEXT_STATUS_UNAVAILABLE = 'unavailable';
export const LAUNCH_CONTEXT_STATUS_EXPIRED = 'expired';
export const LAUNCH_CONTEXT_STATUS_ERROR = 'error';

export const SET_SUBMISSION_CONTEXT = 'app/Flow/SET_SUBMISSION_CONTEXT';
